.ay{min-width:0px;}